import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  HeroTitle,
  Filters,
  FiltersContainer,
  LabelContainer,
  ListingsContainer,
  Listings,
  Wrapper,
  InfoLink,
  PostTitle,
  PostLink,
  InternalPostLink,
  PageLink,
  Posting,
  Pagination,
} from "./styles";
import axios from "axios";

const ITEMS_PER_PAGE = 10;

const normalizeCmsJobs = (cmsJobs) => {
  const now = new Date();
  return cmsJobs
    .filter((job) => {
      const notExpired = !job.jobEndDate || new Date(job.jobEndDate) >= now;
      const started = !job.jobStartDate || new Date(job.jobStartDate) <= now;
      return notExpired && started;
    })
    .map((job) => {
      const parts = (job.jobLocation || "").split(", ");
      return {
        id: job.uid || job.slug,
        name: job.title,
        postingUrl: `/jobs/${job.slug}`,
        locationId: (job.jobLocation || "").replace(", ", "-"),
        location: {
          city: parts[0] || "",
          region: parts[1] || "",
          remote: job.jobRemote || false,
        },
        customField: [{ fieldLabel: "Brands", valueLabel: job.jobBrand }],
        isInternal: true,
      };
    });
};

const loadCareers = async (
  cmsJobs,
  setLocations,
  setPostings,
  setPaginationPage,
  setTotalPages,
  setFilterFlag
) => {
  const result = await axios.get(
    "https://api.smartrecruiters.com/v1/companies/Savant1/postings"
  );
  const content = result?.data?.content || [];

  let locations = [];
  const richContent = content.map((posting) => {
    const urlName = posting.name
      .replace(/[\W_]+/g, "")
      .replace(/\s\s+/g, " ")
      .replace(/ /g, "-");
    const postingUrl = `https://jobs.smartrecruiters.com/Savant1/${posting.id}-${urlName}`;

    const cityString = `${posting.location.city}, ${posting.location.region}`;
    if (!locations.includes(cityString)) {
      locations.push(cityString);
    }
    return {
      ...posting,
      postingUrl,
      locationId: cityString.replace(", ", "-"),
    };
  });

  const normalizedCmsJobs = normalizeCmsJobs(cmsJobs);
  for (const job of normalizedCmsJobs) {
    const cityString = `${job.location.city}, ${job.location.region}`;
    if (cityString !== ", " && !locations.includes(cityString)) {
      locations.push(cityString);
    }
  }

  const allPostings = [...richContent, ...normalizedCmsJobs];
  setLocations(locations);
  setPostings(allPostings);
  setTotalPages(Math.ceil(allPostings.length / ITEMS_PER_PAGE));
  setPaginationPage(0);
  setFilterFlag(-1);
};

const Careers = ({ cmsJobs = [] }) => {
  const [paginationPage, setPaginationPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [locations, setLocations] = useState([]);
  const [filters, setFilters] = useState({});
  const [filterFlag, setFilterFlag] = useState(0);
  const [postings, setPostings] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);

  useEffect(() => {
    loadCareers(
      cmsJobs,
      setLocations,
      setPostings,
      setPaginationPage,
      setTotalPages,
      setFilterFlag
    );
  }, [cmsJobs]);

  const updateFilters = useCallback(
    (evt) => {
      filters[evt.target.value] = !filters[evt.target.value];
      setFilters(filters);
      setFilterFlag(filterFlag + 1);
    },
    [filters, filterFlag, setFilters, setFilterFlag]
  );

  useEffect(() => {
    const newFilteredPosts = postings.filter((posting) => {
      let result =
        !filters[posting.locationId] &&
        !filters[
          posting.customField.filter((f) => f.fieldLabel === "Brands")[0]
            .valueLabel
        ];
      if (posting.location.remote) {
        result = result && !filters?.remote;
      } else {
        result = result && !filters?.local;
      }
      return result;
    });
    setFilteredPosts(newFilteredPosts);
    setTotalPages(Math.ceil(newFilteredPosts.length / ITEMS_PER_PAGE));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterFlag]);

  return (
    <Container>
      <HeroTitle>Careers</HeroTitle>
      <div>
        <Wrapper>
          <FiltersContainer>
            <Filters>
              <h4>OPEN POSITIONS</h4>
              <br />
              <LabelContainer className="container">
                <span className="label-text">Savant</span>
                <input
                  type="checkbox"
                  id="savantCheckbox"
                  name="savantCheckbox"
                  value="Savant"
                  onChange={updateFilters}
                  checked={!filters["Savant"]}
                />
                <span className="checkmark"></span>
              </LabelContainer>
              <LabelContainer className="container">
                <span className="label-text">Savant Power</span>
                <input
                  type="checkbox"
                  id="racepointCheckbox"
                  name="racepointCheckbox"
                  value="Savant Power"
                  onChange={updateFilters}
                  checked={!filters["Savant Power"]}
                />
                <span className="checkmark"></span>
              </LabelContainer>

              <LabelContainer className="container">
                <span className="label-text">
                  GE Lighting, a Savant Company
                </span>
                <input
                  type="checkbox"
                  id="geCheckbox"
                  name="geCheckbox"
                  value="GE Lighting, a Savant Company"
                  onChange={updateFilters}
                  checked={!filters["GE Lighting, a Savant Company"]}
                />
                <span className="checkmark"></span>
              </LabelContainer>

              <br />
              <LabelContainer className="container">
                <span className="label-text">Local</span>
                <input
                  type="checkbox"
                  id="localCheckbox"
                  name="localCheckbox"
                  value="local"
                  onChange={updateFilters}
                  checked={!filters["local"]}
                />
                <span className="checkmark"></span>
              </LabelContainer>

              <LabelContainer className="container">
                <span className="label-text">Remote</span>
                <input
                  type="checkbox"
                  id="remoteCheckbox"
                  name="remoteCheckbox"
                  value="remote"
                  checked={!filters["remote"]}
                  onChange={updateFilters}
                />
                <span className="checkmark"></span>
              </LabelContainer>
              <br />
              {locations.map((location) => {
                const locationId = location.replace(", ", "-");
                return (
                  <LabelContainer
                    key={`location-${locationId}`}
                    className="container"
                  >
                    <span className="label-text">{location}</span>
                    <input
                      type="checkbox"
                      id={locationId}
                      name={locationId}
                      value={locationId}
                      onChange={updateFilters}
                      checked={!filters[locationId]}
                    />
                    <span className="checkmark"></span>
                  </LabelContainer>
                );
              })}

              <h6>
                <InfoLink href="/careers-privacy/en-us">
                  Privacy Policy USA
                </InfoLink>
              </h6>

              <h6>
                <InfoLink href="/careers-privacy/zh-cn">
                  Privacy Policy China
                </InfoLink>
              </h6>

              <h6>
                <InfoLink href="/careers-privacy/en-ca">
                  Privacy Policy Canada
                </InfoLink>
              </h6>

              <h6>
                <InfoLink href="/careers-privacy/fr-ca">
                  Privacy Policy French Canada
                </InfoLink>
              </h6>
            </Filters>
          </FiltersContainer>
          <ListingsContainer>
            <Listings>
              <ul>
                {filteredPosts
                  .slice(
                    paginationPage * ITEMS_PER_PAGE,
                    paginationPage * ITEMS_PER_PAGE + ITEMS_PER_PAGE
                  )
                  .map((posting) => {
                    const brandLabel = posting.customField.filter(
                      (f) => f.fieldLabel === "Brands"
                    )[0]?.valueLabel;
                    return (
                      <Posting key={`posting-${posting?.id}`}>
                        <div>
                          <PostTitle>{posting?.name}</PostTitle>
                        </div>
                        <div>
                          <div>
                            {posting.isInternal ? (
                              <InternalPostLink to={posting.postingUrl}>
                                Read More
                              </InternalPostLink>
                            ) : (
                              <PostLink
                                href={posting.postingUrl}
                                target="_blank"
                              >
                                Read More
                              </PostLink>
                            )}
                            {brandLabel && <span> ({brandLabel})</span>}
                          </div>
                        </div>
                      </Posting>
                    );
                  })}
              </ul>
            </Listings>
          </ListingsContainer>
        </Wrapper>
        <Pagination>
          {[...Array(totalPages).keys()].map((page) => {
            return (
              <PageLink
                key={`page-${page}`}
                onClick={() => setPaginationPage(page)}
                active={page === paginationPage}
              >
                {page + 1}
              </PageLink>
            );
          })}
          {paginationPage < totalPages - 1 && (
            <PageLink onClick={() => setPaginationPage(paginationPage + 1)}>
              NEXT
            </PageLink>
          )}
          <span style={{ width: "2em" }} />
        </Pagination>
      </div>
    </Container>
  );
};

export default Careers;
